
import { Vue } from "vue-class-component";

export default class ArrowUp extends Vue {}
